// Pure URL validation shared by auth returns and the existing Radio owner.
export function parseRadioInvitation(value, origin = window.location.origin) {
  try {
    const url = new URL(value, origin);
    const keys = [...url.searchParams.keys()];
    const capsule = url.pathname === '/home';
    if (url.origin !== origin || url.username || url.password || !['/hitlab/radio', '/home'].includes(url.pathname) || url.hash ||
        (capsule && (url.searchParams.get('radio') !== '1' || url.searchParams.get('source') !== 'jg-radio-rotation-drop')) ||
        keys.some(k => !(capsule ? ['radio', 'track', 'source', 'invitation'] : ['track', 'source', 'invitation']).includes(k)) || new Set(keys).size !== keys.length ||
        !/^[a-z0-9](?:[a-z0-9-]{0,118}[a-z0-9])?$/.test(url.searchParams.get('track') || '') ||
        (url.searchParams.has('source') && url.searchParams.get('source') !== 'jg-radio-rotation-drop') ||
        (url.searchParams.has('invitation') && !/^[a-f0-9]{24}$/i.test(url.searchParams.get('invitation')))) return null;
    return { trackId: url.searchParams.get('track'), invitation: url.searchParams.get('invitation') || '', capsule,
      entrySurface: capsule || url.searchParams.get('source') === 'jg-radio-rotation-drop' || url.searchParams.has('invitation') ? 'notification' : 'capsule',
      url: `${url.pathname}${url.search}` };
  } catch (_) { return null; }
}

// Notification click boundary only. Ordinary public Radio links remain public.
export function radioNotificationDestination(value, origin = window.location.origin) {
  const intent = parseRadioInvitation(value, origin);
  if (!intent) return null;
  const query = new URLSearchParams({ radio: '1', source: 'jg-radio-rotation-drop', track: intent.trackId });
  if (intent.invitation) query.set('invitation', intent.invitation);
  return `/home?${query}`;
}
